import { useState, useEffect } from "react";
// imports of the components
import Footer from "./homepage/Footer";
import "./public_routes_css/home_page.css";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Swiper, SwiperSlide } from "swiper/react";
import IsLoading from "../../isLoading.jsx";

// MUI import
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SchoolIcon from "@mui/icons-material/School";
import HandshakeIcon from "@mui/icons-material/Handshake";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import ApprovalIcon from "@mui/icons-material/Approval";
import InfoIcon from "@mui/icons-material/Info";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import Carousel from "./public-routs-comps/home-comps/Carousel";
import Feature from "./public-routs-comps/home-comps/Feature";
import PvMessage from "./public-routs-comps/home-comps/PvMessage";
import Admrequirement from "./public-routs-comps/home-comps/AdmRequirement";
import Gallery from "./public-routs-comps/home-comps/Gallery";
import CTA from "./public-routs-comps/home-comps/CTA.jsx";

// import images
import fImga from "../public_directory/public-routs-comps/home-comps/home-page-images/a.png";
import fImgb from "../public_directory/public-routs-comps/home-comps/home-page-images/b.webp";
import fImgc from "../public_directory/public-routs-comps/home-comps/home-page-images/c.png";
import fImgd from "../public_directory/public-routs-comps/home-comps/home-page-images/d.png";
import fImge from "../public_directory/public-routs-comps/home-comps/home-page-images/e.png";
import fImgf from "../public_directory/public-routs-comps/home-comps/home-page-images/f.png";
import Logo3d from "./homepage/home_pictures/logos/Logo3d.png";
import Logo from "./homepage/home_pictures/logos/Manga_Cons _Logo.png";
import Logo2 from "./homepage/home_pictures/logos/Manga_Cons _Logo2.png";
import Logo3 from "./homepage/home_pictures/logos/Manga_Cons _Logo3.png";
import MenuIcon from "@mui/icons-material/Menu";

function HeroSections() {
  return (
    <>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>
          <section className="mcons-home-hero a1 fx-cl">
            <h2>Manga-CONS</h2>
            <p>
              Empowering future <strong>Nurses</strong> to make a difference.
            </p>
          </section>
        </SwiperSlide>
        <SwiperSlide>
          <section className="mcons-home-hero c fx-cl">
            <h2>Application form</h2> <p>is Out!. Start your application</p>
            <Link to="/registrations" className="hero_apply_btn">
              Apply now
            </Link>
          </section>
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <section className="mcons-home-hero a fx-cl">
            <h2>Compassion</h2>
            <p>Empowering nurses through compassion and care.</p>
          </section>
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <section className="mcons-home-hero b fx-cl">
            <h2>Excellence</h2>
            <p>Commitment to excellence in every patient interaction.</p>
          </section>
        </SwiperSlide>

        <SwiperSlide>
          {" "}
          <section className="mcons-home-hero d fx-cl">
            <h2>Innovation</h2>
            <p>Leading the way with innovative nursing education.</p>
          </section>
        </SwiperSlide>
      </Swiper>
    </>
  );
}

const HomePage = () => {
  const [loading, setLoading] = useState(false);
  const [showHeader, setShowHeader] = useState(false);
  const [navMenuActive, setNavMenuActive] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > lastScrollTop && scrollTop > 100) {
      setShowHeader(true); // Show header if scrolling down and not at the top
    } else if (scrollTop <= 100) {
      setShowHeader(false); // Hide header if near the top
    } else {
      setShowHeader(true); // Show header if scrolling up
    }
    setLastScrollTop(scrollTop <= 0 ? 0 : scrollTop); // For Mobile or negative scrolling
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  return (
    <section className="mcons-home-container">
      {loading ? <IsLoading></IsLoading> : null}
      <header
        className={`mcons-home-header rwdHide  ${
          showHeader ? "mcons-home-show-header" : "mcons-home-hide-header"
        }`}
      >
        <nav className="mcons-home-navbar">
          <div className="mcons-home-logo">
            {/* <figure className="loginLogo">
                        <img src={Logo} alt="mcons-logo" /> 
                    </figure> */}
            <Link>
              <strong>Manga-CONS</strong>
            </Link>
          </div>

          <ul
            className={`mcons-home-nav-menu fx-ac ${
              navMenuActive ? "mcons-home-nav-menu-active" : ""
            }`}
          >
            <div className="home-nav dropdown">
              <li className="fx-ac ">
                <AdminPanelSettingsIcon fontSize="large" />
                <Link to="/administration" className="fx-ac ">
                  <span>Administrations</span>
                  <KeyboardArrowRightIcon fontSize="large" />
                </Link>
              </li>

              <div className="home-nav dropdown-content ">
                <div className="administrationDropdown">
                  <Link href="#home">Provost</Link>
                  <Link href="#home">Deputy Provost Admin</Link>
                  <Link href="#home">Deputy Provost Academic</Link>
                  <Link href="#home">Registrar</Link>
                  <Link href="#home">STDO</Link>
                  <Link href="#home">College Bursar</Link>
                  <Link href="#home">Chief Internal Auditor</Link>
                  <Link href="#home">College Librarian</Link>
                  <Link href="#home">Admission Officer</Link>
                  <Link href="#home">Examination Officer</Link>
                  <Link href="#home">Students Affair Officer</Link>
                  <Link href="#home">Academic Secretary</Link>
                </div>
              </div>
            </div>
            <div className="home-nav dropdown">
              <li className="fx-ac ">
                <SchoolIcon fontSize="large" />
                <Link to="/academics" className="fx-ac ">
                  <span>Academics</span>
                  <KeyboardArrowRightIcon fontSize="large" />
                </Link>
              </li>
              <div className="home-nav dropdown-content">
                <Link href="#home">Basic Midwifery </Link>
                <Link href="#services">Basic Nursing</Link>
                <Link href="#about">Division of General Studies</Link>
              </div>
            </div>
            <div className="home-nav dropdown">
              <li className="fx-ac ">
                <HandshakeIcon fontSize="large" />
                <Link className="fx-ac ">
                  <span>Admission</span>
                  <KeyboardArrowRightIcon fontSize="large" />
                </Link>
              </li>
              <div className="home-nav dropdown-content">
                <Link to="/admission_status">Check Admission Status</Link>
                <Link to="/mangacons_requirement">Admission requirement</Link>
              </div>
            </div>
            <li className="fx-ac ">
              <LibraryBooksIcon fontSize="large" />
              <Link to="/library">Library</Link>
            </li>

            <div className="home-nav dropdown">
              <li className="fx-ac ">
                <ApprovalIcon fontSize="large" />
                <Link className="fx-ac ">
                  <span>Application</span>
                  <KeyboardArrowRightIcon fontSize="large" />
                </Link>
              </li>

              <div className="home-nav dropdown-content">
                <Link to="/registrations">Apply now</Link>
                <Link to="/how_to_apply">How to apply</Link>
                <Link to="/mangacons_requirement">Admission requirement</Link>
              </div>
            </div>
          </ul>
          <div className="fx-ac space2">
            <span>
              <Link to="/staff_login">Staffs</Link>
            </span>

            <Link className="home-nav-btn-b" to="/student_login">
              Student portal
            </Link>
          </div>
        </nav>
      </header>

      <main style={{ position: "relative" }}>
        <div className="mcons-home-navbar-b-cont fx-cl rwdHide">
          <h1 className="fx space2 ">
            <img src={Logo3d} alt="mcons_logo" />
            <div className="fx-cl fx-jc headerBanner spacem">
              <h2>MANGA COLLEGE OF NURSING SCIENCES</h2>
              <span>Knowledge for Promoting Health Care Delivery Services</span>
              {/* <p>
                Empowering Future Caregivers with Knowledge, Compassion, and
                Excellence. We nurture skills, inspire growth, and build a
                legacy of care. Begin your journey with us today.
              </p> */}
            </div>
          </h1>

          <nav className="mcons-home-navbar-b">
            <ul
              className={`mcons-home-nav-menu-b fx-ac ${
                navMenuActive ? "mcons-home-nav-menu-active" : ""
              }`}
            >
              <div className="home-nav dropdown">
                <li className="fx-ac ">
                  <AdminPanelSettingsIcon fontSize="large" />
                  <Link to="/administration" className="fx-ac ">
                    <span>Administrations</span>
                    <KeyboardArrowRightIcon fontSize="large" />
                  </Link>
                </li>

                <div className="home-nav dropdown-content ">
                  <div className="administrationDropdown">
                    <Link href="#home">Provost</Link>
                    <Link href="#home">Deputy Provost Admin</Link>
                    <Link href="#home">Deputy Provost Academic</Link>
                    <Link href="#home">Registrar</Link>
                    <Link href="#home">STDO</Link>
                    <Link href="#home">College Bursar</Link>
                    <Link href="#home">Chief Internal Auditor</Link>
                    <Link href="#home">College Librarian</Link>
                    <Link href="#home">Admission Officer</Link>
                    <Link href="#home">Examination Officer</Link>
                    <Link href="#home">Students Affair Officer</Link>
                    <Link href="#home">Academic Secretary</Link>
                  </div>
                </div>
              </div>
              <div className="home-nav dropdown">
                <li className="fx-ac ">
                  <SchoolIcon fontSize="large" />
                  <Link to="/academics" className="fx-ac ">
                    <span>Academics</span>
                    <KeyboardArrowRightIcon fontSize="large" />
                  </Link>
                </li>
                <div className="home-nav dropdown-content">
                  <Link href="#home">Basic Midwifery </Link>
                  <Link href="#services">Basic Nursing</Link>
                  <Link href="#about">Division of General Studies</Link>
                </div>
              </div>
              <div className="home-nav dropdown">
                <li className="fx-ac ">
                  <HandshakeIcon fontSize="large" />
                  <Link className="fx-ac ">
                    <span>Admission</span>
                    <KeyboardArrowRightIcon fontSize="large" />
                  </Link>
                </li>
                <div className="home-nav dropdown-content">
                  <Link to="/admission_status">Check Admission Status</Link>
                  <Link to="/mangacons_requirement">Admission requirement</Link>
                </div>
              </div>
              <li className="fx-ac ">
                <LibraryBooksIcon fontSize="large" />
                <Link to="/library">Library</Link>
              </li>

              <div className="home-nav dropdown">
                <li className="fx-ac ">
                  <ApprovalIcon fontSize="large" />
                  <Link className="fx-ac ">
                    <span>Application</span>
                    <KeyboardArrowRightIcon fontSize="large" />
                  </Link>
                </li>

                <div className="home-nav dropdown-content">
                  <Link to="/registrations">Apply now</Link>
                  <Link to="/how_to_apply">How to apply</Link>
                  <Link to="/mangacons_requirement">Admission requirement</Link>
                </div>
              </div>

              <li className="fx-ac ">
                <InfoIcon fontSize="large" />
                <Link to="/about-us">About </Link>
              </li>
              <li className="fx-ac ">
                <RecentActorsIcon fontSize="large" />
                <Link to="/contact-us">Contant us</Link>
              </li>
            </ul>
            <div className="fx-ac space2">
              <span>
                <Link style={{ color: "#041e15" }} to="/staff_login">
                  Staffs
                </Link>
              </span>
              <Link className="home-nav-btn" to="/student_login">
                Student portal
              </Link>{" "}
            </div>
          </nav>
        </div>
        <HeroSections />
        <div className="mobileNavCont">
          <div
            className="mcons-home-nav-toggle"
            onClick={() => setNavMenuActive(!navMenuActive)}
          >
            <MenuIcon fontSize="large" />
          </div>
          <div
            className={`mobileNav ${navMenuActive ? "mobileNavToggle" : ""}`}
          >
            <ul
              className={`mcons-home-nav-menu fx-ac ${
                navMenuActive ? "mcons-home-nav-menu-active" : ""
              }`}
            >
              <div className="home-nav dropdown">
                <li className="fx-ac ">
                  <AdminPanelSettingsIcon fontSize="large" />
                  <Link to="/administration" className="fx-ac ">
                    <span>Administrations</span>
                    <KeyboardArrowRightIcon fontSize="large" />
                  </Link>
                </li>

                <div className="home-nav dropdown-content ">
                  <div className="administrationDropdown">
                    <Link href="#home">Provost</Link>
                    <Link href="#home">Deputy Provost Admin</Link>
                    <Link href="#home">Deputy Provost Academic</Link>
                    <Link href="#home">Registrar</Link>
                    <Link href="#home">STDO</Link>
                    <Link href="#home">College Bursar</Link>
                    <Link href="#home">Chief Internal Auditor</Link>
                    <Link href="#home">College Librarian</Link>
                    <Link href="#home">Admission Officer</Link>
                    <Link href="#home">Examination Officer</Link>
                    <Link href="#home">Students Affair Officer</Link>
                    <Link href="#home">Academic Secretary</Link>
                  </div>
                </div>
              </div>
              <div className="home-nav dropdown">
                <li className="fx-ac ">
                  <SchoolIcon fontSize="large" />
                  <Link to="/academics" className="fx-ac ">
                    <span>Academics</span>
                    <KeyboardArrowRightIcon fontSize="large" />
                  </Link>
                </li>
                <div className="home-nav dropdown-content">
                  <Link href="#home">Basic Midwifery </Link>
                  <Link href="#services">Basic Nursing</Link>
                  <Link href="#about">Division of General Studies</Link>
                </div>
              </div>
              <div className="home-nav dropdown">
                <li className="fx-ac ">
                  <HandshakeIcon fontSize="large" />
                  <Link to="/mangacons_requirement" className="fx-ac ">
                    <span>Admission</span>
                    <KeyboardArrowRightIcon fontSize="large" />
                  </Link>
                </li>
                <div className="home-nav dropdown-content">
                  <Link to="/admission_status">Check Admission Status</Link>
                  <Link to="/mangacons_requirement">Admission requirement</Link>
                </div>
              </div>
              <li className="fx-ac ">
                <LibraryBooksIcon fontSize="large" />
                <Link to="/library">Library</Link>
              </li>

              <div className="home-nav dropdown">
                <li className="fx-ac ">
                  <ApprovalIcon fontSize="large" />
                  <Link className="fx-ac ">
                    <span>Application</span>
                    <KeyboardArrowRightIcon fontSize="large" />
                  </Link>
                </li>

                <div className="home-nav dropdown-content">
                  <Link to="/registrations">Apply now</Link>
                  <Link to="/how_to_apply">How to apply</Link>
                  <Link to="/mangacons_requirement">Admission requirement</Link>
                </div>
              </div>

              <li className="fx-ac ">
                <InfoIcon fontSize="large" />
                <Link to="/about-us">About </Link>
              </li>
              <li className="fx-ac ">
                <RecentActorsIcon fontSize="large" />
                <Link to="/contact-us">Contant us</Link>
              </li>
              <li className="fx-ac ">
                <SupervisorAccountIcon fontSize="large" />
                <Link to="/student_login">Student Login</Link>
              </li>
            </ul>
          </div>
        </div>
        <section className="section-edu-body fx-cl space1">
          <h3>Manga CONS Educational Bodies</h3>
          <p className="edu-body-discription">
            Our educational landscape is guided by several key organizations
            that ensure high standards and quality in education.
          </p>
          <figure className="edu-body-logo rdwHide fx-jc space3 ">
            <div style={{ width: "19rem" }}>
              <img src={fImga} alt="" />
            </div>
            <div>
              <img src={fImgb} alt="" />
            </div>
            <div>
              <img src={fImgc} alt="" />
            </div>
            <div>
              <img src={fImgd} alt="" />
            </div>
            <div>
              <img src={fImge} alt="" />
            </div>
            <div>
              <img src={fImgf} alt="" />
            </div>
          </figure>
        </section>

        {/* <section className="heading-one fx-cl space2">
                    <h1>
                    Manga College of Nursing Sciences
                    </h1>
                    <p>We advance education and healthcare with innovative programs and dedicated faculty, fostering a convergence of passionate students, cutting-edge research, and compassionate care to develop future leaders in science and nursing.</p>
                </section> */}
        <PvMessage />
        <Admrequirement />
        <Gallery />
        <CTA />
        <Feature />
        <Carousel />
      </main>
      <Footer setLoading={setLoading} />
    </section>
  );
};

export default HomePage;
